import { get } from "@/utils/request"
//视频监控列表
export function getProjectCamera() {
  return get("/camera/getProjectCamera")
}
